<template>
  <div class="profit-loss-reports reports main-content">
    <div class="page-header">
      <h3 class="page-title"> {{ $tc('reports.report', 2) }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/supplier/dashboard">
            {{ $t('general.home') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/supplier/reports/sales">
            {{ $tc('reports.report', 2) }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2">
          <base-button icon="download" size="large" color="theme" @click="onDownload()">
            {{ download_button_txt }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <!-- Tabs -->
        <ul class="tabs">
          <li class="tab">
            <router-link class="tab-link" to="/super-admin/reports/preapprovedInvoice-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.preapprovedInvoice_report.invoice_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/super-admin/reports/disbursement-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.disbursement.disbursement_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/super-admin/reports/payment-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.payment.payment_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/super-admin/reports/payment-outstanding-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.payment.payment_outstanding_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/super-admin/reports/on-time-payment-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.ontime_payment.ontime_payment_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/super-admin/reports/payment-receipt-report">{{ $t('reports.payment_recipt.payment_recipt_report') }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition
      name="fade"
      mode="out-in">
      <router-view ref="report" />
    </transition>
  </div>
</template>

<script>
export default {
  data(){
    return {
      download_button_txt:'Download PDF'
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue === '/super-admin/reports') {
        this.$router.push('/super-admin/reports/preapprovedInvoice-report')
      }
    }
  },
  created () {
    if (this.$route.path === '/super-admin/reports') {
      this.$router.push('/super-admin/reports/preapprovedInvoice-report')
    }
  },
  methods: {
    onDownload () {
      this.$refs.report.downloadReport()
    },
    changeDownloadButtonTxt(txt){
      this.download_button_txt=txt
    }
  }

}
</script>

<style scoped>
.tab {
  padding: 0 !important;
}

.tab-link {
  padding: 10px 30px;
  display: block
}
</style>
